export default __webpack_public_path__ + "static/media/hr.77e30da2.svg";